import "./ContactUs.css";

import { useRef, useState } from "react";

import axios from "axios";
import { useAuthHeader } from "react-auth-kit";

function ContactUs() {
  const authHeader = useAuthHeader();

  const [message, setMessage] = useState("");
  const [requestStatus, setRequestStatus] = useState({ error: false, message: "" });

  const messageRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    // Disable submit button
    const submitButton = document.getElementsByClassName("contact-us-form-button-submit")[0];
    submitButton.disabled = true;

    const searchParams = new URLSearchParams({
      message: message
    });

    const url = `${process.env.REACT_APP_BASE_URL}/user/support?${searchParams.toString()}`
    const data = {};
    const config = {
      headers: {
        "accept": "application/json",
        "Authorization": authHeader()
      },
    };
    axios.post(url, data, config)
      .then(response => {
        messageRef.current.value = "";
        setRequestStatus({ error: false, message: response.data.message });
      })
      .catch(error => {
        if (error.response) {
          if (typeof error.response.data.detail === "string") {
            setRequestStatus({ error: true, message: error.response.data.detail });
          } else {
            setRequestStatus({ error: true, message: "Something went wrong, please try again later" });
          }
        } else {
          setRequestStatus({ error: true, message: "Unable to connect to server" });
        }
        // Re-enable submit button
        submitButton.disabled = false;
      });
  };

  const setInputs = (event) => {
    setMessage(messageRef.current.value);
  }

  return (
    <div className="contact-us-container">
      <h1 className="contact-us-header">Contact Us</h1>
      <p className="contact-us-description-text">
        If you require any support or have any recommendations, please feel free to contact us!
        Enter your message below and we will get back to you as soon as possible.
      </p>
      <form className="contact-us-form" onSubmit={handleSubmit}>
        <textarea className="contact-us-form-input-message" placeholder="Please type your message here!" ref={messageRef} onChange={setInputs} />
        {requestStatus.message !== "" && <p className={requestStatus.error === false ? "contact-us-form-request-status-success" : "contact-us-form-request-status-error"}>{requestStatus.message}</p>}
        <button className="contact-us-form-button-submit" type="submit">Send</button>
      </form>
    </div>
  );
}

export default ContactUs;